import * as React from 'react';

import ClosingCostItem from './ClosingCostItem';

import styles from '../../../../styles/sass/pages/Tools.module.scss';

export interface Props {
  closingCosts: any;
  closingCostsItems: any;
  showToriiBrokerage: boolean;
  toggleSwitch: any;
}

class ClosingCostsTable extends React.Component<Props, {}> {
  render() {
    const {
      closingCosts,
      closingCostsItems,
      showToriiBrokerage,
      toggleSwitch,
    } = this.props;
    const closingCostsList = () =>
      closingCostsItems &&
      closingCostsItems.map((item: any, index: number) => (
        <ClosingCostItem
          key={index}
          label={item.label}
          value={item.value}
          tooltip={item.description}
        />
      ));

    return (
      <div className={styles.closingCostsTable}>
        <div className={styles.closingCostLists}>
          <ClosingCostItem
            label={closingCosts.label}
            value={closingCosts.value}
            title
          />
          {closingCostsList()}
        </div>
      </div>
    );
  }
}

export default ClosingCostsTable;
